import {civiiChat} from '@/civii-chat/actions/civiiChatActions.js'
import {clearOutput} from './utils/general'


export const actions = {
    //civiiChat,
  async askFeedback ({output}) {
    let ct = output.contexto.contents
    let message = window.civiiConf.askFeedbackMessage
    if (ct != null && ct.askFeedbackMessage != null) {
      message = ct.askFeedbackMessage
    }
    output.outputWatson.json_response.push(message)
    output.outputWatson.cancelAccept = {type: 'negativepositive'}
    output.outputWatson.disableInput = true
    delete output.contexto.actions.before
    output.contexto.actions.after = ['_.checkFeedback']
    return output
  },
  async checkFeedback ({output}) {
    if (output.message === 'true') {
      output.skipWatson = true
      delete output.contexto.actions.after
      output.contexto.actions.before = ['_.positiveFeedback']
    } else {
      output.message = '_error'
      delete output.contexto.actions
      delete output.contexto.contents
    }
    return output
  },
  async positiveFeedback ({output}) {
    let ct = output.contexto.contents
    let message = window.civiiConf.positiveAnswerMessage
    if (ct != null && ct.positiveAnswerMessage != null) {
      message = ct.positiveAnswerMessage
    }
    output.outputWatson.json_response.push(message)
    return clearOutput(output, 'contents')
  }
}



// WEBPACK FOOTER //
// ./src/defaultActions.js